import InputField from "components/utils/InputField"
import GetpackedLoginButton from "components/utils/loginButtons/GetpackedLoginButton"
import { getAuth, sendPasswordResetEmail } from "firebase/auth"
import { getHost } from "hooks/misc/useHost"
import { useState } from "react"

interface PasswordResetFormProps {
  defaultEmail?: string
}

const PasswordResetForm = ({ defaultEmail }: PasswordResetFormProps) => {
  const [email, setEmail] = useState(defaultEmail || "")
  const [error, setError] = useState<undefined | "email" | "other">(undefined)

  const handleReset = async () => {
    setError(undefined)
    const { origin } = getHost()
    try {
      getAuth().languageCode = "de"
      await sendPasswordResetEmail(getAuth(), email, { url: `${origin}/` })
    } catch (error) {
      if (error) {
        console.error(error)
        //TODO: Adjust for signup errors, this is a login error
        setError((error as Error).message.includes("auth/user-not-found") ? "email" : "other")
      }
    }
  }

  const errorMessage =
    error &&
    {
      email: "Ein Nutzer mit dieser E-Mail existiert nicht.",
      other: "Ein Fehler ist aufgetreten, versuche es nachher nochmal",
    }[error]

  const buttonEnabled = !!email

  return (
    <>
      <style jsx>{`
        @keyframes slidein {
          from {
            max-height: 0px;
            opacity: 0;
          }

          to {
            max-height: 24px;
            opacity: 1;
          }
        }
        .errorMessage {
          margin: 0;
          max-height: 24px;
          opacity: 1;
          animation: slidein 0.15s linear;
        }
      `}</style>
      <InputField danger={error === "email"} type="email" value={email} onChange={e => setEmail(e.target.value)}>
        E-Mail Adresse
      </InputField>

      {errorMessage ? <p className="errorMessage">{errorMessage}</p> : null}
      <GetpackedLoginButton onClick={handleReset} disabled={!buttonEnabled} reset />
    </>
  )
}

export default PasswordResetForm
